import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            My name is <span className="purple">Jesse Campanella</span>.
            <br />I am a gamer by nature - which means I am used to wearing many hats, filling different roles, multi-tasking under pressure, and problem-solving at a competitive level.
            <br />
            <br />I have been working in the IT industry since graduating high school in 2014. Along the way I have held a range of titles: IT Support, Service Desk Analyst, Service Desk Supervisor, Knowledge Base Administrator, and Project Coordinator - among others. Lately, that list has grown to include building AI agents and internal tooling, which has become a genuine focus of mine.
            <br />
            <br />
            Outside of work, you will find me:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Gaming - World of Warcraft, League of Legends, Starcraft, Warzone, and whatever happens to be the current obsession.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> Building things - from custom PCs and Twitch stream setups to AI agents and internal tooling. If it can be built, I want to try it.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> Hiking - Virgin Falls {'(2019, 2020, 2021)'}, Cummins Falls, Mammoth Caves, Fall Creek Falls. Always looking for the next one.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> Cooking - I am no professional, but I take peppers and spices seriously.
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "SCV ready."{" "}
          </p>
          <footer className="blockquote-footer">Terran SCV, Starcraft</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
